import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getInitiateIvSelector } from '../selectors'
import { setAddToTimeLine } from '../store/initiateIv.actions'
import { InitiateIvConstants } from '../store/initiateIv.constants'
import { IInitiateIvState } from '../store/initiateIv.types'
import { addInitiateIvItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { getUpdatedProcedureStateWithNemsisCode, handleNemsisCodeError } from '../../../../utilities/nemsisCode.util'

export function* saveInitiateIv() {
  const initiateIvStateWithDefaults: IInitiateIvState = yield select(getInitiateIvSelector)
  let initiateIvState: IInitiateIvState = {
    ...initiateIvStateWithDefaults,
    initiateIvDefaults: null,
  }

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    initiateIvState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: initiateIvState,
      actionField: (s) => s.iVType?.name,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    initiateIvState = handleNemsisCodeError(error, initiateIvState)
  }

  try {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.initiateIvStateList && pcrDoc.patient?.initiateIvStateList.length) {
      const index = pcrDoc.patient?.initiateIvStateList?.findIndex(
        (initiateIv) => initiateIv.key === initiateIvState.key
      )
      if (index !== -1) {
        pcrDoc.patient.initiateIvStateList[index] = initiateIvState
      } else {
        pcrDoc.patient?.initiateIvStateList.push(initiateIvState)
      }
    } else {
      pcrDoc.patient = { ...pcrDoc.patient, initiateIvStateList: [initiateIvState] }
    }
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addInitiateIvItem())
  } catch (e) {
    yield put(throwPcrException(`saveInitiateIv() error: ${e}`))
  }
}

export function* saveInitiateIvSaga() {
  yield takeLatest(
    [
      InitiateIvConstants.SAVE_INITIATE_IV,
      InitiateIvConstants.SET_DATE,
      InitiateIvConstants.SET_TIME,
      InitiateIvConstants.SET_DATE_TIME,
      InitiateIvConstants.SET_ASSESSED_BY,
      InitiateIvConstants.SET_RESPONSE,
      InitiateIvConstants.SET_RESPONSE_PNNV,
      InitiateIvConstants.SET_PROCEDURE_COMPLICATIONS,
      InitiateIvConstants.SET_AUTHORIZATION,
      InitiateIvConstants.SET_ATTEMPTS,
      InitiateIvConstants.SET_ROLE_PERFORMING,
      InitiateIvConstants.SET_ROLE_PERFORMING_PNNV,
      InitiateIvConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      InitiateIvConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      InitiateIvConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveInitiateIv
  )
}
